import {action, observable, runInAction} from 'mobx'
import GenericFormStore from '../../../stores/FormStore';
import userStore from '../../../stores/UserStore';
import {go} from "../../../utils/navigationUtility";
import registrationStore from "../store";
import {customEvent} from "../../../utils/analyticsUtil";
import {events} from "../../../constants/enums";

class SignUpStore extends GenericFormStore {
    @observable isAuthenticating = false;
    @observable signUpDone = false;

    @observable form = {
        fields: {
            email: {
                value: '',
                error: '',
                rule: 'required|email'
            },
            name: {
                value: '',
                error: '',
                rule: 'required'
            },
            password: {
                value: '',
                error: '',
                rule: 'required|password'
            },
        },
        meta: {
            isValid: true,
            error: null,
        },
    };

    @action
    async signUp() {
        let {fields} = this.form;
        let signUpFormFields = {};
        customEvent(events.EmailSignUpButtonClick);
        Object.keys(fields).forEach(field => {
            signUpFormFields[field] = fields[field].value;
        });
        try {
            this.isAuthenticating = true;
            registrationStore.authenticating = true;
            const {email, password} = signUpFormFields;
            await userStore.register(signUpFormFields);
            await userStore.login(email, password);
            go('/students/activity');
            runInAction(() => {
                this.isAuthenticating = false;
                registrationStore.authenticating = false;
                this.signUpDone = true;
            })
        } catch (err) {
            runInAction(() => {
                this.isAuthenticating = false;
                registrationStore.authenticating = false;
                this.signUpDone = false;
                switch (err.code) {
                    case 'InvalidParameterException':
                        this.form.meta.error = 'Please fill all the fields';
                        break;
                    case 'UserLambdaValidationException':
                        try {
                            const errorDetails = JSON.parse('{' + err.message.split('{')[1].slice(0,-1));
                            if (errorDetails.provider === 'Cognito') {
                                this.form.meta.error = 'This email is already in use.<br/>Please go to the log-in page.';
                            } else {
                                this.form.meta.error = `This email was already used to register using ${errorDetails.provider}, please login with your ${errorDetails.provider} account`;
                            }
                        } catch (err) {
                            this.form.meta.error = err.message;
                        }
                        break;
                    default:
                        this.form.meta.error = err.message;
                }

            })
        }
    }

    @action confirm = async (username, code) => {
        try {
            // this.isAuthenticating = true;
            // await userStore.confirmUser(username, code);
            go('login', {username: username});
        } catch (err) {
            runInAction(() => {
                this.error = {
                    msg: err.message
                };
            })
        }
    };

    @action onClickDone = () => {
        go('/signin');
    }

}

const signUpStore = new SignUpStore();
export default signUpStore;
